import type { ParametrosAplicativo } from "../../../services/parametrosAplicativo"

export type ParametrosAplicativoModel = ParametrosAplicativo

export const ParametrosAplicativoInicial: ParametrosAplicativoModel = {
    // ── Públicos — texto ────────────────────────────────────────────────────
    tagManager: null,
    pixelFacebook: null,
    googleAnalytics: null,
    projectName: null,
    nomeRemetenteEmail: null,
    tokenGoogleMaps: null,
    tokenMapBox: null,
    // ── Públicos — selects ──────────────────────────────────────────────────
    categoria: null,
    tipoEndereco: 0,
    tipoSelecaoEndereco: 0,
    tipoEntregaBairro: 0,
    tipoBloqueio: 1,
    // ── Públicos — checkboxes ───────────────────────────────────────────────
    cardapioEmGrid: false,
    exibirFormasGanharDesconto: true,
    mostrarAPartirDe: false,
    mostrarWhatsapp: false,
    limitarQuantidadeItensCentral: true,
    inicioTelaLogin: false,
    permitirContinuarSemCadastro: true,
    permiteRemoverDesconto: false,
    solicitarComanda: false,
    solicitarNomePedidoMesa: true,
    solicitarTelefonePedidoMesa: true,
    permitirDesconectarMesa: true,
    permitirIncrementarQuantidadeProduto: true,
    registrarHistoricoAberturaCardapio: false,
    exibirBotaoCancelarPedidoAoCliente: false,
    redirecionarParaSitePrincipal: false,
    // ── Meta ────────────────────────────────────────────────────────────────
    podeEditar: true,
    ehClienteFiel: false,
    // ── ClienteFiel — Funcionalidades App ───────────────────────────────────
    possuiAplicativo: false,
    possuiDelivery: false,
    possuiFidelidade: false,
    possuiModuloEntregadores: false,
    possuiModuloPedidosMesa: false,
    exibirRegistroPedidos: false,
    possuiMarketingAutomatico: false,
    possuiControleCaixa: false,
    exibirTodasUnidadesNoDelivery: false,
    permiteRetiradaBalcao: false,
    permiteConsumoNoLocal: false,
    exibirLojasOcultas: false,
    permiteEscolherPagamentoMesa: false,
    apenasRetiradaNaLoja: false,
    permiteIncluirLojas: false,
    cpfObrigatorio: false,
    validarTelefoneCartaoCredito: false,
    permiteLoginTelefone: false,
    loginApenasTelefone: false,
    enviarSmsPeloFirebase: false,
    clienteFielStart: false,
    validarTelefoneAntesDeRealizarPedido: false,
    representante: false,
    buscaProdutosPaginada: false,
    exigeCobrancaVerificacaoCartaoOnline: false,
    exibirBairrosEstabelecimentoEntregaCadastroEndereco: false,
    redirecionarClientesAppIosparaSite: false,
    // ── ClienteFiel — Layout App ─────────────────────────────────────────────
    exibirDesenvolvidoPor: false,
    exibirMesmoFundoTodasAsTelas: false,
    exibirLogoNaSplash: false,
    splashImagemPersonalizada: false,
    webViewNavegador: false,
    exibirRepetirPedido: false,
    // ── ClienteFiel — Outros booleans ────────────────────────────────────────
    resgateRestritoMaisSelos: false,
    exibirVendasRestritoAplicativo: false,
    iniciarCategoriasFechadas: false,
    habilitarConsiderarMedia: false,
    contabilizarPedidosClienteAplicativo: false,
    envioNotificacaoOtimizado: false,
    pararMarketingAutomaticoQuandoFechado: false,
    enviarMsgConfirmacaoMarketingAutomatico: false,
    // ── ClienteFiel — Selects ────────────────────────────────────────────────
    telaPedidos: null,
    telaPrincipalAplicativo: null,
    // ── ClienteFiel — Navegação (Telas) ──────────────────────────────────────
    acao1: null,
    acao2: null,
    acao3: null,
    acao4: null,
    acao5: null,
    icone1: null,
    icone2: null,
    icone3: null,
    icone4: null,
    icone5: null,
    urlwebView: null,
    // ── ClienteFiel — Frases ─────────────────────────────────────────────────
    fraseTelaSelos: null,
    fraseTelaPromocao: null,
    fraseDesenvolidoPor: null,
    fraseCartelaCompleta: null,
    textoPromocaoIndicacao: null,
    textoConvidarAmigos: null,
    textoSobre: null,
    // ── ClienteFiel — Outros texto/número ────────────────────────────────────
    enderecoRemetenteEmail: null,
    selosPorIndicacaoConvidante: 1,
    selosPorIndicacaoConvidado: 1,
    plataforma: null,
    facebookApplicationId: null,
    tokenCashBack: null,
    contatoSuporteApp: null,
    firebaseWeb: null,
    urlRibon: null,
    // ── ParametroEstabelecimento ─────────────────────────────────────────────
    imprimirEntregador: null,
    taxaEntregaNaComanda: null,
    encaminharAtendenteHumano: null,
}

// ── Tipos de metadados ────────────────────────────────────────────────────────

type CampoTextoPublicoKey =
    | "tagManager"
    | "pixelFacebook"
    | "googleAnalytics"
    | "projectName"
    | "nomeRemetenteEmail"
    | "tokenGoogleMaps"
    | "tokenMapBox"

type CampoTextoClienteFielKey =
    | "fraseTelaSelos"
    | "fraseTelaPromocao"
    | "fraseDesenvolidoPor"
    | "fraseCartelaCompleta"
    | "textoPromocaoIndicacao"
    | "textoConvidarAmigos"
    | "textoSobre"
    | "enderecoRemetenteEmail"
    | "plataforma"
    | "facebookApplicationId"
    | "tokenCashBack"
    | "contatoSuporteApp"
    | "firebaseWeb"
    | "urlRibon"

export type CampoTexto = {
    campo: CampoTextoPublicoKey | CampoTextoClienteFielKey
    label: string
    descricao?: string
    multiline?: boolean
}

type CampoBooleanKey =
    | "cardapioEmGrid"
    | "exibirFormasGanharDesconto"
    | "mostrarAPartirDe"
    | "mostrarWhatsapp"
    | "limitarQuantidadeItensCentral"
    | "inicioTelaLogin"
    | "permitirContinuarSemCadastro"
    | "permiteRemoverDesconto"
    | "solicitarComanda"
    | "solicitarNomePedidoMesa"
    | "solicitarTelefonePedidoMesa"
    | "permitirDesconectarMesa"
    | "permitirIncrementarQuantidadeProduto"
    | "registrarHistoricoAberturaCardapio"
    | "exibirBotaoCancelarPedidoAoCliente"
    | "redirecionarParaSitePrincipal"
    | "possuiAplicativo"
    | "possuiDelivery"
    | "possuiFidelidade"
    | "possuiModuloEntregadores"
    | "possuiModuloPedidosMesa"
    | "exibirRegistroPedidos"
    | "possuiMarketingAutomatico"
    | "possuiControleCaixa"
    | "exibirTodasUnidadesNoDelivery"
    | "permiteRetiradaBalcao"
    | "permiteConsumoNoLocal"
    | "exibirLojasOcultas"
    | "permiteEscolherPagamentoMesa"
    | "apenasRetiradaNaLoja"
    | "permiteIncluirLojas"
    | "cpfObrigatorio"
    | "validarTelefoneCartaoCredito"
    | "permiteLoginTelefone"
    | "loginApenasTelefone"
    | "enviarSmsPeloFirebase"
    | "clienteFielStart"
    | "validarTelefoneAntesDeRealizarPedido"
    | "representante"
    | "buscaProdutosPaginada"
    | "exigeCobrancaVerificacaoCartaoOnline"
    | "exibirBairrosEstabelecimentoEntregaCadastroEndereco"
    | "redirecionarClientesAppIosparaSite"
    | "exibirDesenvolvidoPor"
    | "exibirMesmoFundoTodasAsTelas"
    | "exibirLogoNaSplash"
    | "splashImagemPersonalizada"
    | "webViewNavegador"
    | "exibirRepetirPedido"
    | "resgateRestritoMaisSelos"
    | "exibirVendasRestritoAplicativo"
    | "iniciarCategoriasFechadas"
    | "habilitarConsiderarMedia"
    | "contabilizarPedidosClienteAplicativo"
    | "envioNotificacaoOtimizado"
    | "pararMarketingAutomaticoQuandoFechado"
    | "enviarMsgConfirmacaoMarketingAutomatico"
    | "imprimirEntregador"
    | "taxaEntregaNaComanda"
    | "encaminharAtendenteHumano"

export type CampoBoolean = {
    campo: CampoBooleanKey
    label: string
    descricao?: string
}

export type GrupoCheckboxes = {
    titulo: string
    campos: CampoBoolean[]
}

// ── Arrays pré-divididos por contexto ─────────────────────────────────────────

export const CAMPOS_TEXTO_PUBLICOS: CampoTexto[] = [
    {
        campo: "tagManager",
        label: "ID Google Tag Manager",
        descricao: "Gerenciador de tags para centralizar scripts (pixel, analytics, Google Ads, etc.)",
    },
    { campo: "pixelFacebook", label: "Pixel Facebook" },
    { campo: "googleAnalytics", label: "Google Analytics" },
    { campo: "projectName", label: "Nome do Aplicativo" },
    { campo: "nomeRemetenteEmail", label: "Nome Remetente Email" },
    { campo: "tokenGoogleMaps", label: "Key Google Maps" },
    { campo: "tokenMapBox", label: "Key Map Box" },
]

export const CAMPOS_TEXTO_FRASES: CampoTexto[] = [
    { campo: "fraseTelaSelos", label: "Frase Tela Selos" },
    { campo: "fraseTelaPromocao", label: "Frase Tela Promoção" },
    { campo: "fraseDesenvolidoPor", label: 'Frase "Desenvolvido por"' },
    { campo: "fraseCartelaCompleta", label: "Frase Cartela Completa" },
    { campo: "textoPromocaoIndicacao", label: "Texto Promoção Indicação", multiline: true },
    { campo: "textoConvidarAmigos", label: "Texto Convidar Amigos", multiline: true },
    { campo: "textoSobre", label: "Texto Sobre", multiline: true },
]

export const CAMPOS_TEXTO_TECNICOS: CampoTexto[] = [
    { campo: "enderecoRemetenteEmail", label: "E-mail Remetente" },
    { campo: "plataforma", label: "Plataforma" },
    { campo: "facebookApplicationId", label: "Facebook Application ID" },
    { campo: "tokenCashBack", label: "Token Cash Back" },
    { campo: "contatoSuporteApp", label: "Contato Suporte App" },
    { campo: "firebaseWeb", label: "Firebase Web" },
    { campo: "urlRibon", label: "URL Ribon" },
]

export const GRUPOS_CHECKBOXES_PUBLICOS: GrupoCheckboxes[] = [
    {
        titulo: "Site",
        campos: [
            { campo: "cardapioEmGrid", label: "Cardápio em modo grid" },
            { campo: "exibirFormasGanharDesconto", label: "Exibir formas de ganhar descontos" },
            { campo: "mostrarWhatsapp", label: "Exibir WhatsApp" },
            { campo: "inicioTelaLogin", label: "Login ser a tela inicial" },
            {
                campo: "permitirContinuarSemCadastro",
                label: "Permitir pedido sem cadastro",
                descricao: "Permite que o usuário faça um pedido sem se cadastrar",
            },
            { campo: "redirecionarParaSitePrincipal", label: "Redirecionar para o site principal" },
        ],
    },
    {
        titulo: "Produtos e Delivery / Desconto",
        campos: [
            { campo: "mostrarAPartirDe", label: 'Exibir "a partir de" nos produtos' },
            { campo: "permiteRemoverDesconto", label: "Permitir remover desconto automático do delivery" },
            { campo: "limitarQuantidadeItensCentral", label: "Validar quantidade de itens (Central Pedidos)" },
        ],
    },
    {
        titulo: "Pedido de Mesa",
        campos: [
            { campo: "solicitarComanda", label: "Solicitar QR Code da Comanda ao final do pedido" },
            { campo: "solicitarNomePedidoMesa", label: "Solicitar nome ao final do pedido" },
            { campo: "solicitarTelefonePedidoMesa", label: "Solicitar telefone ao final do pedido" },
            { campo: "permitirDesconectarMesa", label: "Permitir desconectar da mesa" },
            { campo: "permitirIncrementarQuantidadeProduto", label: "Permitir incremento na quantidade do produto" },
        ],
    },
    {
        titulo: "Entregadores",
        campos: [
            { campo: "imprimirEntregador", label: "Imprimir Entregador" },
            { campo: "taxaEntregaNaComanda", label: "Taxa de Entrega Visível na Comanda" },
            { campo: "encaminharAtendenteHumano", label: "Encaminhar para Atendente Humano" },
        ],
    },
]

export const GRUPOS_CHECKBOXES_CLIENTEFIEL: GrupoCheckboxes[] = [
    {
        titulo: "Funcionalidades App",
        campos: [
            { campo: "possuiAplicativo", label: "Possui Aplicativo" },
            { campo: "possuiDelivery", label: "Possui Delivery" },
            { campo: "possuiFidelidade", label: "Possui Fidelidade" },
            { campo: "possuiModuloEntregadores", label: "Possui Módulo Entregadores" },
            { campo: "possuiModuloPedidosMesa", label: "Possui Módulo Pedidos Mesa" },
            { campo: "exibirRegistroPedidos", label: "Exibir Registro de Pedidos" },
            { campo: "possuiMarketingAutomatico", label: "Possui Marketing Automático" },
            { campo: "possuiControleCaixa", label: "Possui Controle de Caixa" },
            { campo: "exibirTodasUnidadesNoDelivery", label: "Exibir Todas as Unidades no Delivery" },
            { campo: "permiteRetiradaBalcao", label: "Permite Retirada no Balcão" },
            { campo: "permiteConsumoNoLocal", label: "Permite Consumo no Local" },
            { campo: "exibirLojasOcultas", label: "Exibir Lojas Ocultas" },
            { campo: "permiteEscolherPagamentoMesa", label: "Permite Escolher Pagamento na Mesa" },
            { campo: "apenasRetiradaNaLoja", label: "Apenas Retirada na Loja" },
            { campo: "permiteIncluirLojas", label: "Permite Incluir Lojas" },
            { campo: "cpfObrigatorio", label: "CPF Obrigatório" },
            { campo: "validarTelefoneCartaoCredito", label: "Validar Telefone Cartão de Crédito" },
            { campo: "permiteLoginTelefone", label: "Permite Login por Telefone" },
            { campo: "loginApenasTelefone", label: "Login Apenas por Telefone" },
            { campo: "enviarSmsPeloFirebase", label: "Enviar SMS pelo Firebase" },
            { campo: "clienteFielStart", label: "ClienteFiel Start" },
            { campo: "validarTelefoneAntesDeRealizarPedido", label: "Validar Telefone antes de Realizar Pedido" },
            { campo: "representante", label: "Representante" },
            { campo: "buscaProdutosPaginada", label: "Busca de Produtos Paginada" },
            { campo: "exigeCobrancaVerificacaoCartaoOnline", label: "Exige Cobrança Verificação Cartão Online" },
            {
                campo: "exibirBairrosEstabelecimentoEntregaCadastroEndereco",
                label: "Exibir Bairros do Estabelecimento no Cadastro de Endereço",
            },
            { campo: "redirecionarClientesAppIosparaSite", label: "Redirecionar Clientes App iOS para Site" },
        ],
    },
    {
        titulo: "Layout App",
        campos: [
            { campo: "exibirDesenvolvidoPor", label: 'Exibir "Desenvolvido por"' },
            { campo: "exibirMesmoFundoTodasAsTelas", label: "Exibir Mesmo Fundo em Todas as Telas" },
            { campo: "exibirLogoNaSplash", label: "Exibir Logo na Splash" },
            { campo: "splashImagemPersonalizada", label: "Splash com Imagem Personalizada" },
            { campo: "webViewNavegador", label: "WebView como Navegador" },
            { campo: "exibirRepetirPedido", label: "Exibir Repetir Pedido" },
        ],
    },
    {
        titulo: "Marketing / Pedidos",
        campos: [
            { campo: "resgateRestritoMaisSelos", label: "Resgate Restrito (mais selos)" },
            { campo: "exibirVendasRestritoAplicativo", label: "Exibir Vendas Restrito ao Aplicativo" },
            { campo: "iniciarCategoriasFechadas", label: "Iniciar Categorias Fechadas" },
            { campo: "habilitarConsiderarMedia", label: "Habilitar Considerar Média" },
            { campo: "contabilizarPedidosClienteAplicativo", label: "Contabilizar Pedidos do Cliente pelo Aplicativo" },
            { campo: "envioNotificacaoOtimizado", label: "Envio de Notificação Otimizado" },
            { campo: "pararMarketingAutomaticoQuandoFechado", label: "Parar Marketing Automático quando Fechado" },
            { campo: "enviarMsgConfirmacaoMarketingAutomatico", label: "Enviar Mensagem de Confirmação do Marketing Automático" },
        ],
    },
]

// Combinado — usado nos testes para iterar todos os campos boolean
export const GRUPOS_CHECKBOXES: GrupoCheckboxes[] = [
    ...GRUPOS_CHECKBOXES_PUBLICOS,
    ...GRUPOS_CHECKBOXES_CLIENTEFIEL,
]
